import { supabase } from '../../../integrations/supabase/client';

export interface LeadMessage {
  id: string;
  lead_id: string | null;
  user_id: string;
  content: string;
  sender_type: 'ai' | 'user';
  numero_telefono: string;
  telefono_lead: string;
  media_url: string | null;
  media_type: 'image' | 'audio' | 'video' | 'document' | null;
  message_id: string | null;
  created_at: string;
}

export interface InsertLeadMessage {
  lead_id?: string | null;
  content: string;
  sender_type: 'ai' | 'user';
  numero_telefono: string;
  telefono_lead: string;
  media_url?: string | null;
  media_type?: 'image' | 'audio' | 'video' | 'document' | null;
  message_id?: string | null;
}

export const leadMessagesApi = {
  /**
   * Get all messages for a specific lead
   */
  async getMessagesByLead(leadId: string): Promise<LeadMessage[]> {
    console.log('[leadMessagesApi] 🔍 Buscando mensajes por lead_id:', leadId);

    const { data, error } = await supabase
      .from('lead_messages')
      .select('*')
      .eq('lead_id', leadId)
      .order('created_at', { ascending: true });

    if (error) {
      console.error('[leadMessagesApi] ❌ Error:', error);
      throw error;
    }

    console.log('[leadMessagesApi] ✅ Mensajes encontrados:', data?.length || 0, data);
    return (data || []) as LeadMessage[];
  },

  /**
   * Get messages by phone numbers (lead phone + agent phone)
   */
  async getMessagesByPhone(telefonoLead: string, numeroTelefono?: string): Promise<LeadMessage[]> {
    console.log('[leadMessagesApi] 🔍 Buscando mensajes por teléfono:', { telefonoLead, numeroTelefono });

    let query = supabase
      .from('lead_messages')
      .select('*')
      .eq('telefono_lead', telefonoLead);

    if (numeroTelefono) {
      query = query.eq('numero_telefono', numeroTelefono);
    }

    const { data, error } = await query.order('created_at', { ascending: true });

    if (error) {
      console.error('[leadMessagesApi] ❌ Error:', error);
      throw error;
    }

    console.log('[leadMessagesApi] ✅ Mensajes encontrados:', data?.length || 0, data);
    return (data || []) as LeadMessage[];
  },

  /**
   * Insert a new message (for N8N integration)
   */
  async insertMessage(message: InsertLeadMessage): Promise<LeadMessage> {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('lead_messages')
      .insert({
        ...message,
        user_id: user.id,
      })
      .select()
      .single();

    if (error) throw error;
    return data as LeadMessage;
  },

  /**
   * Get recent messages (for dashboard/export)
   */
  async getRecentMessages(limit: number = 100): Promise<LeadMessage[]> {
    const { data, error } = await supabase
      .from('lead_messages')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return (data || []) as LeadMessage[];
  },
};
